<template>
  <div
    v-click-outside="datePickerHide"
    ref="DatePickerButton"
    class="date-picker-button-wrap"
  >
    <ValidationProvider
      v-slot="{ errors }"
      :rules="rules"
    >
      <input
        type="hidden"
        :value="value"
      >
      <div
        class="date-picker-button"
        :class="{select:startSelect||hasDate,error:errors.length > 0}"
        @click="datePickerShow()"
      >
        <i class="icon-duedate date-icon" />
        <p
          v-if="startSelect && !hasDate"
          class="date-picker-button_text"
        >
          {{ newDateToDate(selectDate) }}
        </p>
        <p
          v-else-if="hasDate"
          class="date-picker-button_text"
        >
          {{ newDateToDate(value) }}
        </p>
        <p
          v-else
          class="date-picker-button_text"
        >
          {{ $t('設定期限') }}
        </p>
      </div>
    </ValidationProvider>
    <transition mode="out-in">
      <vc-date-picker
        v-if="show"
        :value="_value"
        is-inline
        mode="single"
        class="date-picker"
        :class="{
          'drop-up': scroll !== undefined ? isDropUp : false,
        }"
        :min-date="notBeforeDisabledDate?disabledDate:null"
        @input="changeValue($event)"
      />
    </transition>
  </div>
</template>
<script>
import ClickOutside from "vue-click-outside";
import { ValidationProvider } from "vee-validate";
import { extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import H_time from '@/helpers/time';

extend("required", {
  ...required,
  message: "此項目為必填",
});
export default {
  name: "DatePickerButton",
  components: {
    ValidationProvider,
  },
  directives: {
    ClickOutside,
  },
  props: {
    notBeforeDisabledDate: {
      type: Boolean,
      default: false,
    },
    defaultDate: {
      type: Date,
      default: function () {},
    },
    disabledDate: {
      type: Date,
      default: function () {},
    },
    value: {
      type: String,
      default: "",
    },
    textButton: {
      type: Boolean,
      default: false,
    },
    hasDate: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: String,
      default: "",
    },
    scroll: {
      type: Number,
    },
  },
  data: () => ({
    startSelect: false,
    selectDate: "",
    show: false,
    isDropUp: false,
    dropdownHeight: 0,
    dropdownTop: 0,
    windowHeight: 0,
  }),
  computed: {
    _value() {
      if (this.value) {
        return this.$moment(this.value).toDate();
      } else {
        return this.defaultDate;
      }
    },
  },
  watch: {
    value() {
      this.datePickerHide();
    },
    scroll() {
      this.$_getDropdownHeight();
      this.$_isDropdownHide();
    },
  },
  created() {
    window.addEventListener("resize", this.$_handleResize);
    window.addEventListener("resize", this.$_getDropdownHeight);
    window.addEventListener("resize", this.$_isDropdownHide);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.$_handleResize);
    window.removeEventListener("resize", this.$_getDropdownHeight);
    window.removeEventListener("resize", this.$_isDropdownHide);
  },
  mounted() {
    this.$_getDropdownHeight();
    this.$_isDropdownHide();
  },
  methods: {
    changeValue(e) {
      this.startSelect = e !== null;
      this.selectDate = e ? e : '';
      this.$emit("input", this.newDateToDate(e));
    },
    datePickerShow() {
      this.show = true;
    },
    datePickerHide() {
      this.show = false;
    },
    newDateToDate(date) {
      return H_time.getDateDashFormat(date);
    },
    $_handleResize() {
      this.windowHeight = window.innerHeight;
    },
    $_getDropdownHeight() {
      if (!this.$refs.DatePickerButton) {
        return null;
      }
      let dropdownHeight = this.$refs.DatePickerButton.getBoundingClientRect();
      this.dropdownHeight = dropdownHeight.height;
      this.dropdownTop = dropdownHeight.y;
    },
    $_isDropdownHide() {
      this.windowHeight = window.innerHeight;
      if (this.windowHeight - this.dropdownTop >= (this.dropdownHeight + 400)) {
        this.isDropUp = false;
      }
      if (this.windowHeight - this.dropdownTop < (this.dropdownHeight + 400)) {
        this.isDropUp = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
  @import "@/assets/scss/component/date-picker-button";
</style>